module.exports = __webpack_public_path__ + "j.no1.87588e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/j.no1.jpg
// module id = zuqK
// module chunks = 0